export default {"src":"/_next/static/image/public/landing/hand_top.e238023edea73cca34b6d92d82cd65a0.svg","height":174,"width":293};